import { LoadTypeEnum } from "@cai-services";
import { MeasurementUtil } from "../core/_base/crud/utils/measurement.util";
import { SearchItemTemplate } from "../core/_models/search-item-template.model";
import { SearchTemplateItem } from "../core/_models/search-template-item.model";
import { SearchTemplate } from "../core/_models/search-template.model";
import { HomepageCommonUtil } from "./homepage.util";

export class SearchTemplateUtil {
  static parseSearchTemplateItem (template: SearchTemplate): SearchTemplateItem {
    return {
      "searchTemplateId": template.searchTemplateId,
      "savedAsTemplate": template.isSearch,
      "originAirport": template.origin,
      "destAirport": template.destination,
      "searchDate": new Date(template.searchDate),
      "typeOfProduct": template.typeOfProduct?.productCode,
      "timeGroup": HomepageCommonUtil.getTimeGroup(template.searchDate),
      "timeDifference": HomepageCommonUtil.getTimeDifference(template.searchDate),
      "totalVolume": SearchTemplateUtil.calculateTotalVolume(template),
      "totalWeight": SearchTemplateUtil.calculateTotalWeight(
        template.searchItemTemplates
      ),
      "totalPiece": SearchTemplateUtil.calculateTotalPieces(
        template.searchItemTemplates
      ),
      "value": template,
    };
  }

  static calculateTotalPieces (
    searchItemTemplates: SearchItemTemplate[]
  ): number {
    return searchItemTemplates.reduce((acc, curr) => {
      acc += curr.numOfItems;
      return acc;
    }, 0);
  }

  static calculateTotalVolume (searchTemplate: SearchTemplate) {
    return searchTemplate.searchItemTemplates.reduce((acc, curr) => {
      let volume = 0;
      if (curr.itemType === LoadTypeEnum.BUP) {
        volume = curr.volume;
      } else {
        volume = MeasurementUtil.calculateVolume(
          curr.width,
          curr.length,
          curr.height,
          curr.numOfItems,
          searchTemplate.measurementSystem
        );
      }
      acc += volume;
      return acc;
    }, 0);
  }

  static calculateTotalWeight (searchItemTemplates: SearchItemTemplate[]) {
    return searchItemTemplates.reduce((acc, curr) => {
      if (curr.weightType === "TOTAL") {
        acc += curr.weight;
      } else {
        acc += curr.numOfItems * curr.weight;
      }
      return acc;
    }, 0);
  }
}
